import axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

// Define custom headers
const customHeaders = {
    'Content-Type': 'application/json'
};

// sigin 
export const signIn = async (data) => {
    try {
        const response = await axios.post(API_URL + 'login', data, { headers: customHeaders });
        return response;
    } catch (error) {
        console.error('Error fetching categories:', error);
        toast.error(error?.response?.data?.msg);
        throw error;
    }
};

// Fetch all categories
export const fetchAuth = async () => {
    try {
        const response = await axios.get(API_URL, { headers: customHeaders });
        return response;
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error;
    }
};

// Add a new category
export const addAuth = async (newAuth) => {
    try {
        const response = await axios.post(API_URL + 'register', newAuth, { headers: customHeaders });
        return response;
    } catch (error) {
        console.error('Error adding category:', error);
        throw error;
    }
};

// Delete a category by ID
export const deleteAuth = async (id) => {
    try {
        await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
    } catch (error) {
        console.error('Error deleting category:', error);
        throw error;
    }
};

// Update a category by ID
export const updateAuth = async (id, updatedAuth) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, updatedAuth, { headers: customHeaders });
        return response;
    } catch (error) {
        console.error('Error updating category:', error);
        throw error;
    }
};
